import { render, staticRenderFns } from "./reg_sakip.vue?vue&type=template&id=09374d18&"
import script from "./reg_sakip.vue?vue&type=script&lang=js&"
export * from "./reg_sakip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports